import React from 'react';
import RelationPriorsManagement from '../../components/admin/RelationPriorsManagement';

export default function RelationPriorsTab() {
  return <RelationPriorsManagement />;
}
